import { createSlice } from '@reduxjs/toolkit';

// Initial state for shipment form
const initialState = {
  initialData: null,
  isPreFilled: false,
  wasConsumed: false, // Track if data was already consumed to prevent re-filling
};

const shipmentFormSlice = createSlice({
  name: 'shipmentForm',
  initialState,
  reducers: {
        // Set initial data (from Rate Checker, Create Similar, etc.)
    setInitialData: (state, action) => {
      state.initialData = action.payload;
      state.isPreFilled = true;
      state.wasConsumed = false; // Reset consumption flag when new data arrives
    },
    // Clear all data
    clearInitialData: (state) => {
      state.initialData = null;
      state.isPreFilled = false;
      state.wasConsumed = false;
    },
    // Mark as consumed (after form has been pre-filled)
    markAsConsumed: (state) => {
      state.wasConsumed = true;
      // Keep isPreFilled true so data remains available
    },
  },
});

export const { setInitialData, clearInitialData, markAsConsumed } = shipmentFormSlice.actions;

// Selectors
export const selectInitialData = (state) => state.shipmentForm.initialData;
export const selectIsPreFilled = (state) => state.shipmentForm.isPreFilled;
export const selectWasConsumed = (state) => state.shipmentForm.wasConsumed;

export default shipmentFormSlice.reducer;
